module.exports = __webpack_public_path__ + "static/media/example-1.7f464439.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/WestCoastWaste/example-1.jpg
// module id = 312
// module chunks = 0